module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stepper-range"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model:value",
      value: (_vm.min),
      expression: "min",
      arg: "value"
    }],
    ref: "startInput",
    attrs: {
      "type": "number",
      "pattern": "\\d*",
      "min": _vm.range.min,
      "max": _vm.range.max,
      "step": "1"
    },
    domProps: {
      "value": (_vm.min)
    },
    on: {
      "keyup": _vm.handleEvent,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.min = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "stepper-range__divider"
  }, [_vm._v("to:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model:value",
      value: (_vm.max),
      expression: "max",
      arg: "value"
    }],
    ref: "endInput",
    attrs: {
      "type": "number",
      "pattern": "\\d*",
      "min": _vm.range.min,
      "max": _vm.range.max,
      "step": "1"
    },
    domProps: {
      "value": (_vm.max)
    },
    on: {
      "keyup": _vm.handleEvent,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.max = $event.target.value
      }
    }
  }), _vm._v(" "), _c('popover-checkmark-btn', {
    attrs: {
      "disabled": _vm.incorrectValue
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleClick.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ea20e54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/popover/StepperRange.vue
// module id = 1934
// module chunks = 0